// Tree helpers for the nested RFP category system.

export function flattenTree(categories) {
  const byParent = {};
  categories.forEach(c => {
    const key = c.parent_id || '__root__';
    (byParent[key] = byParent[key] || []).push(c);
  });
  Object.values(byParent).forEach(list => list.sort((a, b) => a.name.localeCompare(b.name)));
  const out = [];
  const walk = (parentKey, depth) => {
    (byParent[parentKey] || []).forEach(c => {
      out.push({ ...c, depth });
      walk(c.id, depth + 1);
    });
  };
  walk('__root__', 0);
  // Orphans (parent deleted) still get listed at root level.
  const seen = new Set(out.map(c => c.id));
  categories.filter(c => !seen.has(c.id)).forEach(c => out.push({ ...c, depth: 0 }));
  return out;
}

// All ids in the subtree rooted at rootId (inclusive).
export function descendantIds(categories, rootId) {
  const kids = {};
  categories.forEach(c => { (kids[c.parent_id || '__root__'] = kids[c.parent_id || '__root__'] || []).push(c.id); });
  const out = new Set();
  const stack = [rootId];
  while (stack.length) {
    const cur = stack.pop();
    if (out.has(cur)) continue;
    out.add(cur);
    (kids[cur] || []).forEach(k => stack.push(k));
  }
  return out;
}

export function categoryPath(categories, id) {
  const map = Object.fromEntries(categories.map(c => [c.id, c]));
  const parts = [];
  let cur = map[id];
  let guard = 0;
  while (cur && guard < 10) {
    parts.unshift(cur.name);
    cur = cur.parent_id ? map[cur.parent_id] : null;
    guard += 1;
  }
  return parts.join(' › ');
}

const CHIP_PALETTE = [
  'bg-cyan-50 text-cyan-800 border-cyan-200',
  'bg-rose-50 text-rose-800 border-rose-200',
  'bg-amber-50 text-amber-800 border-amber-200',
  'bg-emerald-50 text-emerald-800 border-emerald-200',
  'bg-violet-50 text-violet-800 border-violet-200',
  'bg-sky-50 text-sky-800 border-sky-200',
  'bg-slate-100 text-slate-700 border-slate-200',
];

export function chipClass(name) {
  let h = 0;
  for (let i = 0; i < (name || '').length; i += 1) h = (h * 31 + name.charCodeAt(i)) % 997;
  return CHIP_PALETTE[h % CHIP_PALETTE.length];
}

// Inline style for a category's admin-picked colour; null → use chipClass fallback.
export function chipStyle(color) {
  if (!color) return null;
  return { backgroundColor: `${color}1A`, color, borderColor: `${color}66` };
}

export const CATEGORY_COLORS = [
  '#0F2040', '#4ABFCF', '#E11D48', '#D97706', '#059669',
  '#7C3AED', '#0284C7', '#DB2777', '#65A30D', '#64748B',
];
